//GeneratorFlag:[NoChange]
import notification from './notification'
export default {
	//items: [notification]
	items: []
} 